import { Flex, Select } from 'antd';

import { SPACE } from '@/shared/design-tokens/design-tokens';
import type { SelectOption } from '@/shared/types';

import styles from './CardRightContent.module.css';

type RightContentProps = {
  DATE_OPTIONS?: SelectOption<number>[];
  selectedDateValue?: number;
  dateRangeText?: string;
  handleSelectDateValue?: (value: number) => void;
};

export const CardRightContent = ({
  DATE_OPTIONS,
  selectedDateValue,
  dateRangeText,
  handleSelectDateValue,
}: RightContentProps) => {
  return (
    <Flex gap={SPACE[8]} align="center">
      <time className={styles.date}>{dateRangeText}</time>
      {DATE_OPTIONS && (
        <Select
          options={DATE_OPTIONS}
          value={selectedDateValue}
          onChange={handleSelectDateValue}
          className={styles.select}
        />
      )}
    </Flex>
  );
};
